export type ChatMessageLink = {
  channelId: string;
  messageId?: string;
};

const CHAT_LINK_PATTERN = /\/chat\/([^/?#]+)(?:\/([^/?#]+))?\/?$/;

// Chaser/notification links point to `.../chat/:channelId/:messageId`. Used to detect
// whether a link targets the channel already open so we can jump in place instead of navigating.
export const parseChatMessageLink = (href: string): ChatMessageLink | null => {
  let pathname = href;

  try {
    pathname = new URL(href, window.location.origin).pathname;
  } catch {
    return null;
  }

  const match = pathname.match(CHAT_LINK_PATTERN);
  if (!match) return null;

  const [, channelId, messageId] = match;
  return { channelId, messageId };
};
